module.exports = "//d274d294w9cx2v.cloudfront.net/9cdefa18723ae35403d502c7e0ee43baf990ca5e/images/payPalBadge.png";